import { FC } from "react";
import cn from "classnames";

import { LoadingOverlay } from "components";
import { FieldSelect } from "components/Common/Field/Select";

import { useGetGroups } from "hooks";

import styles from "./styles.module.scss";

interface Props {
  value: string;
  onSelect: (value: string) => void;
}

export const GroupsSelect: FC<Props> = ({ value, onSelect }) => {
  const { data: groupsData, loading } = useGetGroups();
  const isLoading = loading && groupsData.length === 0;

  const groupsOptions = groupsData;

  const handleSelectChange = (e): void => {
    e.stopPropagation();

    onSelect(e.target.value);
  };

  const containerClassNames = cn({
    [styles.container]: true,
    [styles.emptyList]: isLoading,
  });

  return (
    <div className={containerClassNames}>
      {isLoading ? (
        <LoadingOverlay customStyles={styles.loadingOverlay} />
      ) : (
        <FieldSelect
          inputProps={{
            name: "group-select-field",
            value,
            options: groupsOptions,
            onChange: handleSelectChange,
            labelKey: "name",
            valueKey: "id",
            placeholder: "No group",
            "data-testid": "group-select-field",
            "data-testvalue": groupsOptions.length,
            isClearable: true,
          }}
        />
      )}
    </div>
  );
};
